import { ProgressbarComponent } from './progressbar.component';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module';

@NgModule({
  declarations: [
    ProgressbarComponent,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    NgSelectModule,
    RouterModule,
    TranslateModule,
    ContentEditableModule
  ],
  exports: [
    ProgressbarComponent
  ]
})

export class ProgressbarModule { }
